/* eslint-disable @typescript-eslint/no-explicit-any */
import { payloadToJSON } from '@tock/coretypes';

export interface RequestableState<T> {
  context?: any;
  data?: T;
  isInitialized?: boolean;
  isRequesting: boolean;
  error?: any;
}

export function createRequestableState<T = any>(): RequestableState<T> {
  return {
    context: undefined,
    data: undefined,
    isInitialized: false,
    isRequesting: false,
    error: undefined,
  };
}

type TypeOf<State> = State extends RequestableState<infer A> ? A : never;
export function handleStarting<State>(state: State, action: BaseTockAction<TypeOf<State>>): State {
  const { context } = action;
  const value: RequestableState<TypeOf<State>> = {
    context,
    error: undefined,
    isRequesting: true,
  };

  return {
    ...state,
    ...value,
  };
}

export function handleDone<State>(state: State, action: BaseTockAction<TypeOf<State>>): State {
  const { payload, context } = action;
  const value: RequestableState<TypeOf<State>> = {
    context,
    data: payloadToJSON(payload),
    isInitialized: true,
    isRequesting: false,
  };

  return {
    ...state,
    ...value,
  };
}

export function handleFailed<State>(state: State, action: BaseTockAction<TypeOf<State>>): State {
  const { payload, context } = action;
  const value: RequestableState<TypeOf<State>> = {
    context,
    data: undefined,
    error: payload,
    isInitialized: true,
    isRequesting: false,
  };

  return {
    ...state,
    ...value,
  };
}
